import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import PageLayout from '@/shared/components/PageLayout';

/**
 * Protected wrapper component that only allows authorized ZAPT team members to access content
 * Usage: <AdminAccess>{your protected content}</AdminAccess>
 */
export default function AdminAccess({ children, showPageLayout = true }) {
  const { user } = useAuthContext();

  // Check if user is authenticated and is authorized ZAPT team member
  const authorizedEmails = ['david@zapt.ai', 'phil@zapt.ai'];
  if (!user || !authorizedEmails.includes(user.email)) {
    const accessDeniedContent = (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Restricted</h1>
          <p className="text-gray-600 mb-4">
            This area is only accessible to authorized users.
          </p>
          <div className="text-sm text-gray-500 mb-6">
            {!user ? (
              <p>Please sign in to continue.</p>
            ) : (
              <p>Your account ({user.email}) does not have access to this area.</p>
            )}
          </div>
          <Link
            to="/dashboard"
            className="inline-flex items-center px-4 py-2 bg-zapt-purple text-white rounded-lg hover:bg-zapt-purple/90 transition-colors font-medium"
          >
            Return to Dashboard
          </Link>
        </div>
      </div>
    );

    // Return with or without PageLayout based on prop
    return showPageLayout ? (
      <PageLayout>{accessDeniedContent}</PageLayout>
    ) : (
      accessDeniedContent
    );
  }

  // User is authorized, render the protected content
  return <>{children}</>;
}
